import type { TranslationCatalog } from "../TranslationManager";

export const tr: TranslationCatalog = {
  "labels.cardNumber": "Kart numarası",
  "labels.expirationDate": "Son kullanma tarihi",
  "labels.cvc": "Güvenlik kodu",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "AA / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Kart numaranız geçersiz.",
  "errors.invalidExpiryDate": "Kartınızın son kullanma tarihi geçersiz.",
  "errors.invalidCvc": "Kartınızın güvenlik kodu geçersiz.",
  "errors.incompleteCardNumber": "Kart numaranız eksik.",
  "errors.incompleteExpiryDate": "Kartınızın son kullanma tarihi eksik.",
  "errors.incompleteCvc": "Kartınızın güvenlik kodu eksik.",
  "errors.expiredCard": "Kartınızın süresi dolmuş.",
  "aria.cardNumber": "Kart numarası",
  "aria.expirationDate": "Son kullanma tarihi",
  "aria.cvc": "Güvenlik kodu",
  "aria.cardInput": "Kart bilgileri",
};
